/* Journey leg: scroll-driven dashed-route reveal.
   The dashed path sits under a mask whose solid path animates stroke-dashoffset,
   so the dash pattern stays fixed while the route draws in. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.dataset.dwLegInit) return;
    root.dataset.dwLegInit = '1';

    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal-path]'));
    var waypoints = root.querySelectorAll('[data-wp]');
    if (!reveals.length) return;

    var lens = reveals.map(function (p) {
      var len = p.getTotalLength();
      p.style.strokeDasharray = String(len);
      p.style.strokeDashoffset = String(len);
      return len;
    });

    function setProgress(p) {
      reveals.forEach(function (el, i) {
        el.style.strokeDashoffset = String(lens[i] * (1 - p));
      });
      waypoints.forEach(function (el) {
        el.classList.toggle('is-on', p >= parseFloat(el.dataset.wp || '0'));
      });
    }

    if (reduced.matches) {
      setProgress(1);
      return;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight;
        /* 0 as the leg enters at the bottom; 1 shortly after it fully enters the viewport */
        var total = r.height + vh * 0.30;
        var passed = vh - r.top;
        setProgress(Math.min(1, Math.max(0, passed / total)));
        ticking = false;
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    }, { rootMargin: '25% 0px 25% 0px' });
    io.observe(root);
  }

  function scan() {
    document.querySelectorAll('[data-dw-journey-leg]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-dw-journey-leg]');
    if (el) init(el);
  });
})();
